// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1505":"847877368f877b29","6185":"0964e19553d7a369","7818":"68bfb0fc1602ca36"}[chunkId] + ".js";
};